import React from 'react';
import ICellProps, { ITranchRow } from './ICellProps';
import { BodyCell } from '@creditflowresearch/uilib/Table/DataTable';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

const getCell = ({ row: tranche }: ITranchRow) => tranche.class;

const ClassCell = ({
  rowIndex,
  tranche,
}: ICellProps) => (
  <BodyCell
    name="ClassCell"
    className={ alignStyles.alignLeft }
    rowIndex={ rowIndex }
    rowData={ tranche }
    cellCallback={ getCell }
  />
);

export default ClassCell;
